import styled from 'styled-components';
import { lightGrey3Color } from 'js/config/style';

export default styled.div`
  font-size: 0.8rem;
  font-weight: normal;
  color: ${lightGrey3Color};
`;
